<template>
  <!-- menuL1-->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey="menuId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"

      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_Image" slot-scope="{row}">
        <img style="height: 44px" :src="row.iconUrl" alt="" @click="showbigimg(row.faceUrl,'人脸照片')">
      </template>
      <template slot="opt_t" slot-scope="{row}">
        <a-switch v-hasPermi="['community:localMenu:switch']" @change="changeStatus(row)" :checked="Number(row.status) ? true : false"/>
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{ statusObj[row.status] }}</span>
        </div>
      </template>
    </x-tabula>

    <!-- <big-img ref='bigImg'></big-img> -->
    <add ref='model' @updateTable = 'updateTable'></add>
  </div>
</template>

<script>
// import bigImg from '@/components/bigImg.vue';
import add from './add.vue';
import { empty } from 'ant-design-vue-admin-x';
export default {
  name: 'platManageMenuSet',
  components: {
    add
  },
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '名称',
          props: ['title']
        }, {
          inputType: 'select',
          options: [
            { value: '1', label: '启用' },
            { value: '0', label: '禁用' }
          ],
          handle: '',
          placeholder: '状态',
          props: ['status']
        }
      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          permi: ['community:localMenu:add'],
          handle: () => { this.$refs.model.show(); }
        }
      ],
      rowOptList: [
        {
          text: '二级菜单',
          handle: row => this.toL2(row),
          permi: ['community:localMenu2:list']
        },
        {
          text: '编辑',
          handle: row => { this.$refs.model.show(row.menuId); },
          permi: ['community:localMenu:edit']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => row.isDelete == 0, // 禁用按钮
          permi: ['community:localMenu:remove']
        }
      ],
      columns: [
        {
          title: '菜单图标',
          dataIndex: '',
          align: '',
          width: '',
          scopedSlots: { customRender: 'Image' }
        }, {
          title: '菜单名称',
          dataIndex: 'title',
          align: '',
          width: ''
        },
        {
          title: '排序',
          dataIndex: 'sort',
          align: '',
          width: ''
        },
        {title: '状态', dataIndex: '', align: '', scopedSlots: {customRender: 't'}},
        {title: '状态', dataIndex: 'status', align: '', scopedSlots: {customRender: 'status'}},
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      statusObj: ['禁用', '启用'],
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        title: undefined,
        status: undefined
      },
      listApi: {
        url: '/local/menu/listPage',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/menu/',
        title: '该菜单',
        key: 'title'
        // resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    empty.$on('updateL1', () => {
      this.$refs.table.getTableList();
    });
  },
  methods: {
    toL2 (row) {
      this.$router.push({
        name: 'menuSetLevel2',
        query: {
          menuId: row.menuId
        }
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/local/menu/status/${row.menuId}`,
        params: {
          status: status
        }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    updateTable (res) {
      if (res && res.code == 200) {
        this.$message.success(res.msg);
      }
      this.$refs.table.getTableList();
    },
    showbigimg (img, title) {
      this.$refs.bigImg.show(img, title);
    },
    /** 弹窗详情 */
    modalDetail (row) {
      this.visible = true;
      this.rowData = row;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
